import React, {useEffect, useState} from "react";
import {api} from "../utils/gashtaltAPI";
import Loader from "../components/Loader";
import ErrorPage from "../components/ErrorPage";
import Navbar from "../components/Navbar";
import {Table, TableContainer, Tbody, Td, Thead, Tr} from "@chakra-ui/react";
import {toPersianNumber} from "../utils/numberConversion";
import {useNavigate, useParams} from "react-router-dom";
import FilterTd from "../components/FilterTd";
import DownloadHandler from "../utils/downloadHandler";
import {RiFileExcel2Line} from "react-icons/ri";
import {toast} from "react-toastify";
import TableToolbar from "../components/TableToolbar";
import Pagination from "../components/Pagination";
import EmptyState from "../components/EmptyState";

function Reports(){
    const {examId} = useParams()
    const [params,setParams] = useState({examId})
    const [exams, setExams] = useState([]);
    const [currentPage, setCurrentPage] = useState(1);
    const [startIndex, setStartIndex] = useState(1);
    const [lastPage, setLastPage] = useState(1);
    const [total, setTotal] = useState(0);
    const [error, setError] = useState(null);
    const [loading,setLoading] = useState(false);
    const navigate = useNavigate();

    useEffect(() => {
        const fetchData = async () => {
            setLoading(true);
            try {
                const response = await api.get(`/api/exam/results/all?page=${currentPage}`,{
                    params : params
                })
                const result = response.data.data
                setExams(result.data);
                setStartIndex(result.from);
                setLastPage(result.last_page);
                setTotal(result.total);
            } catch (error) {
                setError(error)
            } finally {
                setLoading(false);
            }
        }
        fetchData();
    }, [params,currentPage]);

    if (loading) return <Loader />
    if (error) return <ErrorPage error={error}/>;
    return (
        <div className="d-flex flex-column h-100">
            <Navbar/>
            <div className="admin-page flex-fill">
                <TableToolbar title="کارنامه ها" count={total}>
                    <button
                        className="btn btn-outline-green d-flex align-items-center gap-1"
                        onClick={() => {
                            if (!params.examId) {
                                toast.info("برای خروجی اکسل ابتدا یک آزمون را انتخاب کنید.", {
                                    position: "bottom-right",
                                });
                                return;
                            }
                            DownloadHandler(
                                `${api.defaults.baseURL}/api/exam/results/export/${params.examId}`,
                                "exam-results.xlsx"
                            );
                        }}
                    >
                        <RiFileExcel2Line style={{fontSize: '1.1rem'}}/>
                        خروجی اکسل
                    </button>
                </TableToolbar>

                <div className="admin-table-card">
                    <TableContainer>
                        <Table variant='striped' colorScheme='teal'>
                            <Thead>
                                <Tr>
                                    <Td>ردیف</Td>
                                    <Td>
                                        <FilterTd
                                            name={"نام و نام خانوادگی"}
                                            defaultValue={params.name}
                                            onSubmit={(value) => {
                                                setParams((prevFilters) => ({
                                                    ...prevFilters,
                                                    name: value,
                                                }));
                                            }}
                                            onCancel={() => {
                                                setParams((prevFilters) => {
                                                    const { name, ...rest } = prevFilters;
                                                    return rest;
                                                });
                                            }}
                                        />
                                    </Td>
                                    <Td>آزمون</Td>
                                    <Td>کارنامه</Td>
                                </Tr>
                            </Thead>
                            <Tbody>
                                {exams.map((exam, index) => (
                                    <Tr key={`${exam.user_id}-${exam.exam_id}`}>
                                        <Td>{toPersianNumber(startIndex+index)}</Td>
                                        <Td>{exam.user_name}</Td>
                                        <Td>{exam.exam_name}</Td>
                                        <Td>
                                            <button
                                                className={`btn btn-outline-green`}
                                                onClick={() => {
                                                    navigate(`/ResultById/${exam.user_id}/${exam.exam_id}`)
                                                }}>
                                                نمایش
                                            </button>
                                        </Td>
                                    </Tr>
                                ))}
                            </Tbody>
                        </Table>
                    </TableContainer>
                    {exams.length === 0 && <EmptyState text="کارنامه ای یافت نشد." />}
                </div>

                <Pagination currentPage={currentPage} lastPage={lastPage} onChange={setCurrentPage} />
            </div>
        </div>
    );
}

export default Reports;
